import { HeadContent, Outlet, createRootRoute } from '@tanstack/react-router';
import { useEffect } from 'react';
import { HostnameProvider } from 'src/shared/contexts/HostnameContext';
import RootProviders from 'src/shared/providers/RootProviders';

export const Route = createRootRoute({
  head: () => ({
    meta: [
      { title: 'Tekst' },
      { name: 'description', content: 'Tekst — AI-powered customer service automation' },
      { charSet: 'UTF-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1.0' },
    ],
    links: [{ rel: 'icon', href: '/favicon.svg' }],
  }),
  component: RootLayout,
  notFoundComponent: NotFound,
  errorComponent: RootError,
});

function RootLayout() {
  useEffect(() => {
    document.getElementById('initial-loader')?.remove();
  }, []);

  return (
    <HostnameProvider>
      <RootProviders>
        <HeadContent />
        <Outlet />
      </RootProviders>
    </HostnameProvider>
  );
}

function NotFound() {
  return null;
}

function RootError({ error: _error }: { error: Error }) {
  return (
    <div className="w-[100vw] h-[100vh] overflow-hidden flex flex-row justify-center items-center grid-container">
      <div className="w-[550px] rounded-lg border bg-card text-card-foreground shadow-sm p-6">
        <h2 className="text-lg font-semibold">Something went wrong</h2>
        <div className="text-sm mt-3">
          Something caused the application to crash. <br />
          Reloading the page might be enough to fix it. <br />
          Feel free to contact us at support@tekst.com if the issue persists.
        </div>
        <div className="flex gap-2 mt-4">
          <button
            onClick={() => window.open('https://status.tekst.com')}
            className="flex-1 px-4 py-2 border rounded-md text-sm"
          >
            Status Page
          </button>
          <button
            onClick={() => {
              localStorage.clear();
              window.location.reload();
            }}
            className="flex-1 px-4 py-2 bg-primary text-white rounded-md text-sm"
          >
            Reload
          </button>
        </div>
      </div>
    </div>
  );
}
